module.exports = __webpack_public_path__ + "static/media/dragon.c6533071.svg";